window.twoBoxesHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    imagesProportions();
  });

  window.addEventListener('resize', () => {
    imagesProportions();
  });


  const imagesProportions = () => {
    Promise.all(Array.from(document.images)
      .filter(img => !img.complete)
      .map(img =>
        new Promise(resolve => {
          img.onload = img.onerror = resolve;
        })))
      .then(() => {
        const images = document.querySelectorAll('.jsImage4x3');

        images.forEach(image => {
          setImageProportions(image, 4, 3, 'y-position')
        });
      });
  };
}
